import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationLoginPostAsyncSlice } from './post';

export const securityAuthenticationLoginReducers = combineReducers({
	post: securityAuthenticationLoginPostAsyncSlice.asyncReducers
});

export const securityAuthenticationLoginWatchers = combineAllWatchers([
	securityAuthenticationLoginPostAsyncSlice.asyncWatchers
]);
